<!--
 * @Author: guoyu
 * @Date: 2020-09-10 15:05:59
 * @LastEditors: your name
 * @LastEditTime: 2021-05-07 11:24:54
 * @Description: 用法照片展示
-->
<template>
  <div>
    <div class="top-container">
      <SwiperCollapse
        class="big-image-sp"
        v-model="currentIndex"
        :options="imageList"
        sNum="1"
        ifIndicator
        showIndex
      >
        <template v-slot="{ item }">
          <el-image class="big-image" :src="item.imageUrl" :preview-src-list="previewList" />
        </template>
      </SwiperCollapse>
      <!-- <div class="image-count">
        {{ currentIndex + 1 }} / {{ imageList.length }}
      </div> -->
    </div>
    <SwiperCollapse
      class="small-image-sp"
      v-model="currentIndex"
      :options="imageList"
      sNum="5"
    >
      <template v-slot="{ item, index }">
        <img
          class="small-image"
          :src="item.imageUrl"
          :class="{ checked: currentIndex === index }"
          @click="currentIndex = index"
        />
      </template>
    </SwiperCollapse>
  </div>
</template>
<script>
import SwiperCollapse from '@/components/common/swiper/swiper-collapse';
export default {
  components: {
    SwiperCollapse
  },
  props: {
    imageList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      currentIndex: 0
    };
  },
  computed: {
    previewList() {
      if(window.innerWidth >= 600) {
        return this.imageList.map(item => {
          return item.imageUrl;
        });
      } else {
        return []
      }
    }
  },
};
</script>
<style lang="scss" scoped>
.top-container {
  position: relative;
  overflow: hidden;
  width: 100%;
  margin-bottom: 8px;
  border-radius: 4px;
}
.big-image-sp {
  width: 365px;
  height: 445px;
  /deep/.el-icon-circle-close {
    color: #ffffff!important;
  }
  /deep/ .arrow-icon {
    font-weight: 700;
    font-size: 29px;
    color: #ffffff;
  }
  /deep/ .left-arrow,
  /deep/ .right-arrow {
    display: none;
    width: 70px;
  }
}
.big-image {
  position: relative;
  width: 365px;
  height: 445px;
  object-fit: cover;
}
.small-image,
.big-image {
  display: block;
  overflow: hidden;
  border: none;
  font-size: 0px;
  /deep/ .el-image__preview {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    height: 100%;
    width: 100%;
    object-fit: cover;
  }
}
.small-image-sp {
  width: 100%;
  height: 64px;
  /deep/ .arrow-icon {
    font-size: 15px;
    font-weight: 700;
    color: #ffffff;
  }
  /deep/ .left-arrow,
  /deep/ .right-arrow {
    top: 50%;
    width: 24px;
    height: 24px;
    margin: 0 8px;
    border-radius: 50%;
    transform: translateY(-50%);
    background: #636d86;
    opacity: 0.5;
  }
}
.small-image {
  height: 64px;
  width: 64px;  
  margin-right: 10px;
  border-radius: 4px;
  object-fit: cover;
}
.image-count {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  bottom: 15px;
  right: 15px;
  height: 28px;
  padding: 0 15px;
  border-radius: 14px;
  font-size: 14px;
  color: #ffffff;
  background: rgba(0, 0, 0, 0.7);
}
.checked {
  border: 2px solid #ec5375;
}
@media screen and (max-width: 599px)  {
  .small-image-sp {
    display: none;
  }
  .big-image-sp {
    width: 100vw;
    height: 445px;
    .big-image {
      width: 100vw;
      height: 445px;
      overflow: hidden;
    }
    /deep/ .el-image__inner {
      width: 100vw;
      height: auto !important;
    }
  }
}
</style>
